import React from "react";
import { Box, Button, Typography, Grid, Paper, Link } from "@mui/material";
import heroImage from "../assets/landing/images/hero-image-desktop.png";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import { Check, Storage } from "@mui/icons-material";
import { APP_URL } from "../globals/const";
import { useTranslation } from "react-i18next";
import leafIcon from "../assets/landing/icons/lucide-leaf-icon.svg";
import underlineIcon from "../assets/landing/icons/underline-icon.svg";

const HeroSection = () => {
  const { t } = useTranslation();
  return (
    <>
      <Box
        display="flex"
        justifyContent="space-center"
        alignItems="center"
        my="50px"
      >
        <Grid
          container
          spacing={4}
          display="flex"
          justifyContent="space-between"
        >
          <Grid item xs={6} sx={{ paddingLeft: "55px" }}>
            <Typography
              fontSize={{ md: "3.5rem", lg: "5rem" }}
              lineHeight={{ md: "60px", lg: "90px" }}
              fontWeight="bold"
            >
              {t("Easy App for Better Farming")}
            </Typography>
            <Box mt={3}>
              <img src={underlineIcon} alt="underline-icon" />
            </Box>
            <Typography
              variant="body1"
              paragraph
              mt="50px"
              fontSize="18px"
              lineHeight="30px"
              fontWeight="500"
            >
              {t(
                "FarmApp is packed with advanced features designed to optimize every aspect of agricultural management."
              )}
            </Typography>

            <Box
              sx={{
                marginTop: "50px",
                display: "flex",
                gap: 4,
              }}
            >
              <Link href={`${APP_URL}/login`}>
                <Button
                  variant="contained"
                  color="primary"
                  sx={{
                    borderRadius: "40px",
                    textTransform: "none",
                    padding: "10px",
                    fontWeight: 500,
                    backgroundColor: "#54BD95",
                    color: "white",
                    "&:hover": {
                      backgroundColor: "#4ba683",
                    },
                    height: "62px",
                    width: "162px",
                  }}
                >
                  <Typography
                    variant="body1"
                    fontSize="18px"
                    lineHeight="100%"
                    fontWeight="500"
                  >
                    {t("Login")}
                  </Typography>
                </Button>
              </Link>

              <Button
                component="a"
                href="https://www.youtube.com/watch?v=M2sI8jYV_fU"
                target="_blank"
                rel="noopener noreferrer"
                startIcon={
                  <PlayCircleOutlineIcon
                    sx={{
                      width: "31.67px",
                      height: "31.67px",
                      border: "1.5px",
                    }}
                  />
                }
                sx={{
                  borderRadius: 28,
                  textTransform: "none",
                  color: "#333",
                  border: "none",
                  "&:hover": {
                    border: "none",
                  },
                }}
              >
                <Typography
                  variant="body1"
                  fontSize="18px"
                  lineHeight="100%"
                  fontWeight="500"
                  marginLeft="14px"
                >
                  {t("View Demo")}
                </Typography>
              </Button>
            </Box>
          </Grid>
          <Grid
            item
            xs={6}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Box elevation={4}>
              {/* Farm Image */}
              <Box mt={2} sx={{ position: "relative" }}>
                <img
                  src={heroImage}
                  alt="Nashik Farm"
                  style={{
                    width: "410px",
                    height: "526px",
                    borderRadius: "8px",
                  }}
                />
                <Box>
                  <Box
                    sx={{
                      position: "absolute",
                      top: "150px",
                      left: "-50px",
                      backgroundColor: "#4535AF",
                      width: "40px",
                      height: "40px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "10px",
                      transform: "rotate(-15deg)",
                    }}
                  >
                    <Check sx={{ color: "white" }} />
                  </Box>
                  <Box
                    sx={{
                      position: "absolute",
                      top: "40px",
                      right: "-40px",
                      backgroundColor: "#FBC75E",
                      width: "50px",
                      height: "50px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "10px",
                      transform: "rotate(15deg)",
                    }}
                  >
                    <Storage sx={{ color: "white" }} />
                  </Box>
                  <Box
                    sx={{
                      position: "absolute",
                      bottom: "-20px",
                      right: "106px",
                      backgroundColor: "#FFAA94",
                      width: "40px",
                      height: "40px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "10px",
                      transform: "rotate(15deg)",
                    }}
                  >
                    <img src={leafIcon} alt="leaf-icon" />
                  </Box>
                </Box>

                <Box sx={{ position: "absolute", top: "30px", left: "-180px" }}>
                  <Paper
                    sx={{
                      backgroundColor: "white",
                      borderRadius: "12px",
                      width: "262px",
                      height: "78px",
                      boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    <Box sx={{ paddingLeft: "20px" }}>
                      <Typography
                        sx={{
                          color: "grey.500",
                          mt: 0.5,
                          fontWeight: 400,
                          fontSize: "12px",
                          paddingTop: "5px",
                        }}
                      >
                        {t("Add Your Farm")}
                      </Typography>
                      <Typography
                        sx={{
                          mt: 0.5,
                          fontSize: "16px",
                          paddingTop: "5px",
                          fontWeight: "500",
                        }}
                      >
                        {t("Nashik Farm")}
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        width: "90%",
                        margin: "auto",
                        height: "1px",
                        backgroundColor: "rgba(0, 0, 0, 0.1)",
                      }}
                    />
                  </Paper>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default HeroSection;
